import SetPinModal from './SetPinModal';

export default SetPinModal;
